module.exports = {"360113001":"沙井街道","360113002":"卫东街道","360113100":"生米镇","360113400":"凤凰洲管理处","360113401":"红角洲管理处","360113402":"九龙湖管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360113.json
// module id = 1364
// module chunks = 0